// extracted by mini-css-extract-plugin
module.exports = {"table-header":"TableHeader_table-header__0mI_o","middle":"TableHeader_middle__W5mKF","middle-without-cdo":"TableHeader_middle-without-cdo__71kj2"};